<!--
/*******************************************************************************
*@ 화면명     : SelfCertn
*@ 화면설명   : SMS/E-MAIL 인증 선택
*@ 사용전문   : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <self-certn-comm
      v-if="getComponents.isSelfCertnComm === true"
      :bizDscd="this.bizDscd"
      :successFnc="this.successFnc"
      :failFnc="this.failFnc"
      :beforeRouterName="this.beforeRouterName"
    />
    <sms-email-certn
      v-if="getComponents.isSmsEmailCertn === true"
      :bizDscd="this.bizDscd"
      :successFnc="this.successFnc"
      :failFnc="this.failFnc"
      :beforeRouterName="this.beforeRouterName"
    />
    <sms-frst-certn
      v-if="getComponents.isSmsFrstCertn === true"
      :bizDscd="this.bizDscd"
      :successFnc="this.successFnc"
      :failFnc="this.failFnc"
      :beforeRouterName="this.beforeRouterName"
    />
  </article>
</template>
<style type="scss" scoped></style>
<script> 
import { mapGetters, mapActions } from "vuex";
import SelfCertnComm from "@/components/page/auth/SelfCertnComm";
import SmsEmailCertn from "@/components/page/auth/SmsEmailCertn";
import SmsFrstCertn from "@/components/page/auth/SmsFrstCertn";

export default {
  props: {
    bizDscd: {
      type: String,
      required: true,
    },
    successFnc: {
      type: Function,
      required: true,
    },
    failFnc: {
      type: Function,
      required: false,
    },
    beforeRouterName: {
      type: String,
      required: true,
    },
  },
  created() {
    this.$log.info("SelfCertn - SMS/EMAIL Certn Main -", this.beforeRouterName);
    this.act_setComponent("SelfCertnComm");
    //this.$store.state.auth.commMotpCertn.components.isSelfCertnComm = true; // 인증 공통처리
    //this.$store.state.auth.commMotpCertn.components.isSmsFrstCertn = false; // sms 최초인증
    //this.$store.state.auth.commMotpCertn.components.isSmsEmailCertn = false; // sms/email 인증
  },
  mounted() {
    //const result = await this.$store.dispatch("auth/commMotpCertn/act001_commMotpCertn");
    //this.$log.info("SelfCertn 고객정보조회 >>> " + result);
    // if (_.isEmpty(this.$store.state.auth.createMotp.selectedSMSCnpt.intnTelDstcd)) {
    //   this.$store.state.auth.commMotpCertn.isSmsFrstCertn = true;
    // }
    // if (this.$store.state.auth.createMotp.selectedSMSCnpt.recvCnsntYn == "1" || !_.isEmpty(this.$store.state.auth.createMotp.selectedSMSCnpt.brncoIntnTelDstcd)) {
    //   //선택한 전화 번호가 동의가 되어있을 경우 or 국가코드가 없는 경우
    //   this.$store.state.auth.commMotpCertn.isSmsFrstCertn = false;
    // } else {
    //   //선택한 전화 번호가 동의가 안되어 있는 경우
    //   this.$store.state.auth.commMotpCertn.isSmsFrstCertn = true;
    // }
  },
  updated() {},
  data() {
    return {};
  },
  components: {
    SelfCertnComm,
    SmsEmailCertn,
    SmsFrstCertn,
  },
  computed: {
    ...mapGetters("auth/commMotpCertn", ["getComponents"]),
  },
  methods: {
    ...mapActions("auth/commMotpCertn", ["act_setComponent"]),
  },
};
</script>